//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'tsu_arcade',
    colors: ['#4aad8b', '#e15147', '#f3b551', '#cec8b8', '#d1af84', '#544e47'],
    stroke: '#251c12',
    background: '#cfc7b9',
    type: 'tsuchimochi',
  },
  {
    name: 'tsu_harutan',
    colors: ['#75974a', '#c83e3c', '#f39140', '#e4ded2', '#f8c5a4', '#434f55'],
    stroke: '#251c12',
    background: '#cfc7b9',
    type: 'tsuchimochi',
  },
  {
    name: 'tsu_akasaka',
    colors: ['#687f72', '#cc7d6c', '#dec36f', '#dec7af', '#ad8470', '#424637'],
    stroke: '#251c12',
    background: '#cfc7b9',
    type: 'tsuchimochi',
  },
];
